import { EpisodeOrderType } from '@diritto/common/episode/constants';
import { Color } from '@diritto/common/style/color';
import { FontWeight, Typography } from '@diritto/common/style/typography';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const EpisodeOrderTypeMenu = ({
  orderType,
  onChangeOrderType,
}: {
  orderType: EpisodeOrderType;
  onChangeOrderType?: (value: EpisodeOrderType) => void;
}) => (
  <StyledOrderTypeWrapper>
    <StyledOrderType
      isActive={orderType === EpisodeOrderType.FirstOrder}
      onClick={() => onChangeOrderType?.(EpisodeOrderType.FirstOrder)}>
      1화부터
    </StyledOrderType>
    <StyledOrderType
      isActive={orderType === EpisodeOrderType.LastOrder}
      onClick={() => onChangeOrderType?.(EpisodeOrderType.LastOrder)}>
      최신순
    </StyledOrderType>
  </StyledOrderTypeWrapper>
);

const StyledOrderTypeWrapper = styled.div`
  display: flex;
  position: absolute;
  right: 0;
`;

const StyledOrderType = styled.div(
  ({ isActive = false }: { isActive?: boolean }) => css`
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
    text-align: center;
    padding: 14px 0;
    margin-left: 10px;

    color: ${Color.Black};
    font-weight: ${isActive ? FontWeight.Bold : FontWeight.Regular};
    ${Typography.XXSmall};
  `,
);
